export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-foreground-900 via-foreground-800 to-foreground-950">
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20pattern%20with%20soft%20geometric%20shapes%20and%20film%20texture%2C%20dark%20elegant%20background%20with%20subtle%20golden%20accents%2C%20minimalist%20entertainment%20design%2C%20warm%20ambient%20atmosphere&width=1200&height=400&seq=app-entry-movie-01&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <div className="relative z-10 flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 text-accent-300 text-xs font-semibold tracking-wide mb-4 whitespace-nowrap">
                多端同步
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
                随时随地 · 畅享追剧
              </h2>
              <p className="text-white/65 text-sm md:text-base leading-relaxed max-w-lg mx-auto lg:mx-0">
                91影视看片下载完美支持手机、平板、电脑和智能电视多端同步观看。无需下载客户端，打开浏览器即点即看，躺在床上也能享受高清大片。天美麻花星空影视免费观看内容同样支持全设备访问，高清免费影视随时随地想看就看。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 mt-6">
                <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-50/10">
                  <i className="ri-smartphone-line text-accent-400 text-lg w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-white/75 text-sm whitespace-nowrap">手机</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-50/10">
                  <i className="ri-tablet-line text-accent-400 text-lg w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-white/75 text-sm whitespace-nowrap">平板</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-50/10">
                  <i className="ri-computer-line text-accent-400 text-lg w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-white/75 text-sm whitespace-nowrap">电脑</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-50/10">
                  <i className="ri-tv-line text-accent-400 text-lg w-5 h-5 flex items-center justify-center"></i>
                  <span className="text-white/75 text-sm whitespace-nowrap">电视</span>
                </div>
              </div>
            </div>
            <div className="flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20modern%20device%20mockup%20showing%20movie%20streaming%20interface%20on%20phone%20and%20laptop%2C%20dark%20cinematic%20UI%20design%2C%20warm%20accent%20colors%2C%20clean%20minimal%20tech%20lifestyle%20aesthetic%2C%20soft%20ambient%20lighting%2C%20premium%20digital%20entertainment%20concept&width=400&height=500&seq=app-device-movie-01&orientation=portrait"
                alt="91影视看片下载 - 多端同步观看"
                className="w-48 md:w-56 h-auto rounded-xl"
                loading="lazy"
                onError={(e) => {
                  (e.currentTarget as HTMLImageElement).style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}